export class AxAlertBanner {


    public ShowMessage(elementName: string, message: string, success: boolean, additionalClasses: string = ""): void {
        let $elem = $('#' + elementName);

        if (success) {
            $elem.html("<div class='ax-alert alert-dismissible ax-alert--inline ax-alert--success ax-pr-5 " + additionalClasses + "'>" + message +
                "<button type='button' class='close pr-2' data-dismiss='alert' aria-label='Close'>" +
                "<span aria-hidden='true' ><i class='las la-times ax-alert-close'></i> </span> " +
                "</button>" +
                "</div>");
        }
        else {
            $elem.html("<div class='ax-alert alert-dismissible ax-alert--inline ax-alert--danger ax-pr-5 " + additionalClasses + "'>" + message +
                "<button type ='button'class='close' data-dismiss='alert' aria-label='Close'> " +
                "<span aria-hidden='true'> <i class='las la-times ax-alert-close'> </i></span> " +
                "</button > " +
                "</div>");
        }
        this.attachCloseEvent($elem);
        $elem.show();
    }

    public ShowWarningMessage(elementName: string, message: string, iconClass: string, additionalClasses: string = ""): void {
        let $elem = $('#' + elementName);

        $elem.html("<div class='ax-alert alert-dismissible ax-alert--inline ax-alert--warning ax-pr-5 " + additionalClasses + "'>" +
            "<span aria-hidden='true'> <i class='" + iconClass + " ax-pr-2'></i></span>" + message +
            "<button type='button' class='close' data-dismiss='alert' aria-label='Close'>" +
            "<span aria-hidden='true' ><i class='las la-times ax-alert-close'></i> </span> " +
            "</button>" +
            "</div>");

        this.attachCloseEvent($elem);
        $elem.show();
    }

    private attachCloseEvent($elem: JQuery<HTMLElement>) {
        $elem.on('click',
            '.close',
            (x) => {
                $(x.delegateTarget).remove();
            });
    }
}